//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pick from 'lodash.pick';
import { add, update, dbTest } from '@/api/visual/db';
export default {
  props: ['dicData'],
  data: function data() {
    return {
      disableSubmit: false,
      wrapperCol: {
        xs: {
          span: 10
        },
        sm: {
          span: 16
        }
      },
      labelCol: {
        xs: {
          span: 5
        },
        sm: {
          span: 5
        }
      },
      title: '新增',
      visible: false,
      confirmLoading: false,
      testLoading: false,
      model: {},
      validatorRules: {
        name: {
          rules: [{
            required: true,
            message: '请输入名称!'
          }]
        },
        driverClass: {
          rules: [{
            required: true,
            message: '请选择驱动类!'
          }]
        },
        username: {
          rules: [{
            required: true,
            message: '请输入用户名!'
          }]
        },
        password: {
          rules: [{
            required: true,
            message: '请输入密码!'
          }]
        },
        url: {
          rules: [{
            required: true,
            message: '请输入连接地址!'
          }]
        },
        remark: {
          rules: [{
            required: false,
            message: '请输入备注!'
          }]
        }
      },
      form: this.$form.createForm(this)
    };
  },
  methods: {
    add: function add() {
      this.title = '新增';
      this.edit({}, false);
    },
    edit: function edit(record, state) {
      var _this = this;

      this.disableSubmit = state;
      this.form.resetFields();
      var obj = {
        name: '',
        driverClass: undefined,
        username: '',
        password: '',
        url: '',
        remark: ''
      };
      this.model = Object.assign(obj, record);
      this.visible = true;
      this.$nextTick(function () {
        _this.form.setFieldsValue(pick(_this.model, 'name', 'driverClass', 'username', 'password', 'url', 'remark'));

        console.log('this.form', _this.form);
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;

      if (!this.disableSubmit) {
        this.form.validateFields(function (err, values) {
          if (!err) {
            console.log('this.model', _this2.model);
            console.log('values', values);
            _this2.confirmLoading = true;
            var formData = Object.assign(_this2.model, values);
            _this2.confirmLoading = false;

            if (!_this2.model.id) {
              add(formData).then(function (res) {
                if (res.success) {
                  _this2.$message.success('新增成功');

                  _this2.$emit('ok');

                  _this2.visible = false;
                } else {
                  _this2.$message.error(res.message);
                }
              }).finally(function () {
                _this2.confirmLoading = false;
              });
            } else {
              update(formData).then(function (res) {
                if (res.success) {
                  _this2.$message.success('修改成功');

                  _this2.$emit('ok');

                  _this2.visible = false;
                } else {
                  _this2.$message.error(res.message);
                }
              }).finally(function () {
                _this2.confirmLoading = false;
              });
            }
          }
        });
      } else {
        this.visible = false;
      }
    },
    handleCancel: function handleCancel() {
      this.visible = false;
    },
    handleTest: function handleTest() {
      var _this3 = this;

      if (!this.disableSubmit) {
        this.form.validateFields(function (err, values) {
          if (!err) {
            _this3.testLoading = true;
            console.log('this.model', _this3.model);
            console.log('values', _this3.model);
            var form = Object.assign(_this3.model, values);

            _this3.setData(form);
          }
        });
      } else {
        this.testLoading = true;
        this.setData(this.model);
      }
    },
    setData: function setData(form) {
      var _this4 = this;

      dbTest({
        driverClass: form.driverClass,
        url: form.url,
        username: form.username,
        password: form.password
      }).then(function (res) {
        var data = res;

        if (data.success) {
          _this4.$message.success('连接成功');
        } else {
          _this4.$message.error('连接失败，请检查相关配置参数');
        }
      }).finally(function () {
        _this4.testLoading = false;
      });
    }
  }
};